/* AK: endless carousels.
   Every list marked [data-akh-loop] that is currently a sideways carousel gets
   copies of its slides before and after the real ones. When the scroll comes to
   rest on a copy it jumps, invisibly, to the same slide in the real set, so
   swiping, the arrows and mouse-drag never reach an end in either direction.
   Copies only exist while the list really scrolls sideways (phone/tablet widths)
   and are removed when it turns back into a grid (desktop).
   Related hooks: global.js SliderComponent.update() (page count / arrows never
   disabled while looping) and product-info.js updateMedia() (copies removed
   before Dawn reorders the gallery on a colour change). */
(function () {
  if (window.akhLoopSlider) return;
  window.akhLoopSlider = true;

  var SELECTOR = '.slider[data-akh-loop]';
  var CLONE = 'data-akh-clone'; // value = index of the real slide it copies
  var LOOPING = 'data-akh-looping';
  var MIN_EACH_SIDE = 6; // slides of copies on each side, so quick repeated swipes never hit the end
  var SETTLE_MS = 160; // quiet time after the last scroll event before jumping
  var ANIMATION_CLASSES = [
    'scroll-trigger',
    'scroll-trigger--offscreen',
    'scroll-trigger--cancel',
    'animate--slide-in',
    'animate--fade-in',
  ];

  var sliders = new Set();
  var states = new WeakMap();
  var touching = false;

  function isClone(el) {
    return el.nodeType === 1 && el.hasAttribute(CLONE);
  }
  function reals(slider) {
    return Array.prototype.filter.call(slider.children, function (el) {
      return !el.hasAttribute(CLONE);
    });
  }
  function clones(slider) {
    return Array.prototype.filter.call(slider.children, isClone);
  }
  // scroll position that shows `el` at the start of the list
  function positionOf(slider, el) {
    return el.getBoundingClientRect().left - slider.firstElementChild.getBoundingClientRect().left;
  }

  // Is the list a sideways carousel right now? Measured on the real slides only.
  function canScroll(slider) {
    var r = reals(slider).filter(function (el) {
      return el.offsetWidth > 0;
    });
    if (r.length < 2) return false;
    var overflow = getComputedStyle(slider).overflowX;
    if (overflow !== 'auto' && overflow !== 'scroll') return false;
    var first = r[0].getBoundingClientRect();
    var last = r[r.length - 1].getBoundingClientRect();
    if (Math.abs(last.top - first.top) > 1) return false; // wrapped into rows = grid
    return last.right - first.left > slider.clientWidth + 2;
  }

  function stripAnimations(root) {
    [root].concat(Array.prototype.slice.call(root.querySelectorAll('.scroll-trigger'))).forEach(function (el) {
      el.classList.remove.apply(el.classList, ANIMATION_CLASSES);
    });
  }

  function makeClone(slide, index) {
    var copy = slide.cloneNode(true);
    copy.setAttribute(CLONE, String(index));
    copy.setAttribute('aria-hidden', 'true');
    copy.removeAttribute('id'); // Dawn counts slides by [id^="Slide-"]: copies must not count
    copy.removeAttribute('data-media-id'); // the gallery finds its photos by this attribute
    copy.removeAttribute('data-shopify-editor-block');
    copy.classList.remove('is-active');
    stripAnimations(copy);
    Array.prototype.forEach.call(copy.querySelectorAll('[id]'), function (el) {
      el.removeAttribute('id');
    });
    Array.prototype.forEach.call(
      copy.querySelectorAll('a, button, input, select, textarea, [tabindex]'),
      function (el) {
        el.setAttribute('tabindex', '-1');
      }
    );
    return copy;
  }

  function setScroll(slider, left) {
    slider.style.setProperty('scroll-behavior', 'auto', 'important');
    slider.scrollLeft = left;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        slider.style.removeProperty('scroll-behavior');
      });
    });
  }

  function activate(slider, index) {
    var r = reals(slider);
    var n = r.length;
    if (n < 2) return;
    var state = states.get(slider);
    state.copies = Math.max(1, Math.ceil(MIN_EACH_SIDE / n));
    r.forEach(stripAnimations); // a real slide must never fade in again after a jump

    var before = document.createDocumentFragment();
    var after = document.createDocumentFragment();
    for (var k = 0; k < state.copies; k++) {
      r.forEach(function (slide, i) {
        before.appendChild(makeClone(slide, i));
        after.appendChild(makeClone(slide, i));
      });
    }
    slider.insertBefore(before, r[0]);
    slider.insertBefore(after, r[n - 1].nextSibling);
    slider.setAttribute(LOOPING, '');
    setScroll(slider, positionOf(slider, r[Math.max(0, Math.min(n - 1, index || 0))]));
    notify(slider);
  }

  function deactivate(slider) {
    if (!slider.hasAttribute(LOOPING) && !clones(slider).length) return;
    clones(slider).forEach(function (el) {
      el.remove();
    });
    slider.removeAttribute(LOOPING);
    notify(slider);
  }

  // let the arrows/counters update right away (Dawn and the gallery listen to "scroll";
  // the real scroll event only arrives with the next rendered frame)
  function notify(slider) {
    slider.dispatchEvent(new Event('scroll'));
  }

  // index of the real slide currently shown first (a copy counts as its original)
  function currentIndex(slider) {
    var kids = Array.prototype.slice.call(slider.children);
    if (!kids.length) return 0;
    var x = slider.scrollLeft;
    var best = kids[0];
    var bestDistance = Infinity;
    kids.forEach(function (el) {
      var d = Math.abs(positionOf(slider, el) - x);
      if (d < bestDistance) {
        bestDistance = d;
        best = el;
      }
    });
    if (isClone(best)) return Number(best.getAttribute(CLONE)) || 0;
    return Math.max(0, reals(slider).indexOf(best));
  }

  // the gallery marks the photo it wants shown (colour change, thumbnail) as .is-active
  function activeIndex(slider) {
    var r = reals(slider);
    for (var i = 0; i < r.length; i++) {
      if (r[i].classList.contains('is-active')) return i;
    }
    return 0;
  }

  function rebuild(slider, index) {
    deactivate(slider);
    if (canScroll(slider)) activate(slider, index);
  }

  // [copies][real slides][copies], nothing missing, nothing in between
  function consistent(slider) {
    var state = states.get(slider);
    var kids = slider.children;
    var n = reals(slider).length;
    var c = state.copies * n;
    if (kids.length !== n + 2 * c) return false;
    for (var i = 0; i < kids.length; i++) {
      if ((i < c || i >= c + n) !== isClone(kids[i])) return false;
    }
    return true;
  }

  // When the scroll is at rest on a copy, jump to the same place in the real set.
  function settle(slider, force) {
    if (!slider.hasAttribute(LOOPING)) return;
    var busy =
      touching || slider.classList.contains('is-dragging') || slider.classList.contains('is-settling');
    if (busy && !force) {
      schedule(slider);
      return;
    }
    var r = reals(slider);
    var after = r.length > 1 ? r[r.length - 1].nextElementSibling : null;
    if (!after) return;
    var start = positionOf(slider, r[0]);
    var step = positionOf(slider, r[1]) - start;
    var width = positionOf(slider, after) - start; // one full set of slides
    if (step <= 0 || width <= 0) return;
    var x = slider.scrollLeft;
    var low = start - step / 2;
    var target = low + ((((x - low) % width) + width) % width);
    if (Math.abs(target - x) >= 1) setScroll(slider, target);
  }

  function schedule(slider) {
    var state = states.get(slider);
    clearTimeout(state.timer);
    state.timer = setTimeout(function () {
      settle(slider);
    }, SETTLE_MS);
  }

  function init(slider) {
    if (sliders.has(slider)) return;
    sliders.add(slider);
    states.set(slider, { copies: 1, timer: null, lastScroll: 0 });

    slider.addEventListener(
      'scroll',
      function () {
        states.get(slider).lastScroll = Date.now();
        schedule(slider);
      },
      { passive: true }
    );
    if ('onscrollend' in window) {
      slider.addEventListener('scrollend', function () {
        settle(slider);
      });
    }

    // Slides replaced or reordered by someone else (colour change in the gallery,
    // theme editor…): rebuild the copies around the new set.
    new MutationObserver(function () {
      if (slider.hasAttribute(LOOPING)) {
        if (!consistent(slider)) rebuild(slider, activeIndex(slider));
      } else if (canScroll(slider)) {
        activate(slider, activeIndex(slider));
      }
    }).observe(slider, { childList: true });

    if (canScroll(slider)) activate(slider, activeIndex(slider));
  }

  function scan(root) {
    if (root.matches && root.matches(SELECTOR)) init(root);
    if (root.querySelectorAll) Array.prototype.forEach.call(root.querySelectorAll(SELECTOR), init);
  }

  // finger on the carousel: never jump mid-gesture, except right at the start
  // when the list is at rest (keeps quick repeated swipes endless too)
  document.addEventListener(
    'touchstart',
    function (e) {
      touching = true;
      var slider = e.target.closest && e.target.closest(SELECTOR);
      if (slider && slider.hasAttribute(LOOPING) && Date.now() - states.get(slider).lastScroll > 90) {
        settle(slider, true);
      }
    },
    { passive: true }
  );
  function touchEnd() {
    if (!touching) return;
    touching = false;
    sliders.forEach(function (slider) {
      if (slider.hasAttribute(LOOPING)) schedule(slider);
    });
  }
  document.addEventListener('touchend', touchEnd, { passive: true });
  document.addEventListener('touchcancel', touchEnd, { passive: true });

  // phone ⇄ desktop layout: add or remove the copies
  var lastWidth = window.innerWidth;
  var resizeTimer = null;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      if (window.innerWidth === lastWidth) return; // mobile address bar only changes the height
      lastWidth = window.innerWidth;
      sliders.forEach(function (slider) {
        if (!slider.isConnected) {
          sliders.delete(slider);
          return;
        }
        rebuild(slider, slider.hasAttribute(LOOPING) ? currentIndex(slider) : 0);
      });
    }, 200);
  });

  // lists that arrive later (Complete the Look loads after the page, theme editor)
  new MutationObserver(function (records) {
    records.forEach(function (record) {
      Array.prototype.forEach.call(record.addedNodes, function (node) {
        if (node.nodeType === 1 && !isClone(node)) scan(node);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  scan(document);
  window.addEventListener('load', function () {
    sliders.forEach(function (slider) {
      if (!slider.hasAttribute(LOOPING) && canScroll(slider)) activate(slider, currentIndex(slider));
    });
  });
})();
